import { render } from "./JournalDetails.vue?vue&type=template&id=f68b633c&ts=true"
import script from "./JournalDetails.vue?vue&type=script&lang=ts"
export * from "./JournalDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__